<template>
  <div class="layout">
    <span class="layout__titulo">{{ titulo }}</span>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="true" />
    <slot />
  </div>
</template>

<script>
export default {
  name: 'LayoutTelas',
  props: {
    titulo: {
      type: String,
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/scss/colors.scss';

.layout {
  position: relative;
  height: auto;
  width: auto;
  padding: 2.5em 1em 1em 1em;
  border-radius: 0.4em;
  box-shadow: 2px 4px 8px $cor-fundo-escura;
  background-color: $cor-fundo-clara;

  &__titulo {
    position: absolute;
    top: -0.325em;
    left: -0.325em;
    padding: 0.2em 0.4em;
    color: $cor-fonte-clara;
    background-color: $cor-principal;
    box-shadow: 2px 4px 8px $cor-fundo-escura;
    border-top-left-radius: 0.4em;
    border-bottom-right-radius: 0.4em;
    font-size: 1.1em;
  }
}

</style>
